export class LicensureDetail {
    id: number;
    licenseNumber: string;
    state: string;
    issuedDate: Date;
    expireDate: Date;
}
